export default __webpack_public_path__ + "static/media/king-abdulaziz-international-airport.a2d44543.png";